import { RouteObject } from 'react-router-dom';
import { FeatureManageAlerts } from './feature-manage-alerts';
import { FeatureManageCvs } from './feature-manage-cv';

export const CANDIDATE_ROUTES: RouteObject[] = [
   {
      path: '/alerts/index',
      Component: FeatureManageAlerts,
   },

   {
      path: '/candidates/my-cv-list',
      Component: FeatureManageCvs,
   },
];
